<template>
  <div>
    <table style="width:100%">
      <thead>
        <tr>
          <td>
            <div class="header-space print">
              &nbsp;
            </div>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="max-width:100px;">
            <div>
              <div class="pa-4 print__container">
                <div>
                  <v-row>
                    <h1>Звіт по наданим послугам</h1>
                    <v-spacer />
                    <div
                      v-if="unableToManageLogs"
                      class="no-print"
                    >
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            v-on="on"
                            @click="showWorklogDetails = !showWorklogDetails"
                          >
                            <v-icon
                              :color="
                                showWorklogDetails ? 'black' : `grey lighten-1`
                              "
                            >
                              {{
                                showWorklogDetails
                                  ? "remove_red_eye"
                                  : "visibility_off"
                              }}
                            </v-icon>
                          </v-btn>
                        </template>
                        <span v-if="showWorklogDetails">Приховати логи часу</span>
                        <span v-else>Показати логи часу</span>
                      </v-tooltip>
                    </div>
                  </v-row>
                  <v-row class="my-2">
                    <v-col cols="6">
                      <span class="pl-2 body-2">
                        Період:
                        <span class="subtitle-1 pl-2 font-weight-bold">
                          {{
                            moment(filter.dateFrom).format("DD.MM.YY")
                          }}
                          -
                          {{ moment(filter.dateTo).format("DD.MM.YY") }}
                        </span>
                      </span>
                    </v-col>
                    <v-col cols="6">
                      <span class="pl-2 body-2">
                        Проект:
                        <span class="subtitle-1 pl-2 font-weight-bold">
                          {{ filter.project.title ? filter.project.title : projects.join(', ') }}
                        </span>
                      </span>
                    </v-col>
                  </v-row>
                  <v-spacer />
                  <v-row class="my-2 d-flex justify-center">
                    <v-col cols="4">
                      <span class="pl-2 body-2">
                        Разом згідно грейдів:
                        <span class="subtitle-1 pl-2 font-weight-bold">
                          {{ updateTotalPayed }}
                          <span class="body-2">год</span>
                        </span>
                      </span>
                    </v-col>
                    <v-col cols="4">
                      <span class="pl-2 body-2">
                        Разом фактично:
                        <span class="subtitle-1 pl-2 font-weight-bold">
                          {{ updateTotalSpent }}
                          <span class="body-2">год</span>
                        </span>
                      </span>
                    </v-col>
                    <v-col cols="4">
                      <span class="pl-2 body-2">
                        Ітого за базовим тарифом:
                        <span class="subtitle-1 pl-2 font-weight-bold">
                          {{ updateTotalPayed }}
                          <span class="body-2">год</span>
                        </span>
                      </span>
                    </v-col>
                  </v-row>
                </div>
                <div
                  v-for="issue in items"
                  :key="issue.key"
                >
                  <h2 class="pl-2 pt-2">
                    Задача {{ issue.key }}
                  </h2>
                  <div>
                    <table
                      width="99.5%"
                      class="table-style ma-2"
                    >
                      <tr>
                        <th class="row-colomn-style">
                          Номер
                        </th>
                        <th class="row-colomn-style">
                          Статус
                        </th>
                        <th class="row-colomn-style">
                          Задача
                        </th>
                        <th class="row-colomn-style">
                          Автор
                        </th>
                        <th class="row-colomn-style">
                          Строк виконання
                        </th>
                        <th class="row-colomn-style">
                          Фактично, год
                        </th>
                        <th class="row-colomn-style">
                          Згідно грейдів (рівня), год
                        </th>
                      </tr>
                      <tr>
                        <td class="row-colomn-style">
                          {{ issue.key }}
                        </td>
                        <td class="row-colomn-style">
                          {{ issue.status }}
                        </td>
                        <td class="row-colomn-style">
                          {{ issue.summary }}
                        </td>
                        <td class="row-colomn-style">
                          {{ issue.author }}
                        </td>
                        <td class="row-colomn-style">
                          {{ issue.dueDate }}
                        </td>
                        <td class="row-colomn-style">
                          {{
                            (
                              issue.worklog.reduce(
                                (sum, n) => sum + n.timeSpentSeconds,
                                0
                              ) / 3600
                            ).toFixed(2)
                          }}
                        </td>
                        <td class="row-colomn-style">
                          {{
                            (
                              issue.worklog.reduce(
                                (sum, n) => sum + n.payedSeconds,
                                0
                              ) / 3600
                            ).toFixed(2)
                          }}
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div class="pl-5">
                    <div v-if="issue.description">
                      <h3>Опис Виконавця:</h3>
                      <div v-html="findWorkingImage(issue)" />
                    </div>
                    <div v-if="issue.customerDescription">
                      <h3>Опис замовника (звернення клієнта):</h3>
                      <div v-html="issue.customerDescription" />
                    </div>
                    <div v-if="showWorklogDetails">
                      <h3>Лог часу:</h3>
                      <table
                        width="100%"
                        class="table-style my-2 mr-2 ml-0"
                      >
                        <tr>
                          <th class="row-colomn-style">
                            Дата
                          </th>
                          <th class="row-colomn-style">
                            Виконавець
                          </th>
                          <th class="row-colomn-style">
                            Час, год
                          </th>
                          <th class="row-colomn-style">
                            Опис логу часу
                          </th>
                          <th class="row-colomn-style">
                            Згідно грейдів (рівня), год
                          </th>
                        </tr>
                        <tr
                          v-for="(w, index) in issue.worklog"
                          :key="index"
                        >
                          <td class="row-colomn-style">
                            {{ w.date }}
                          </td>
                          <td class="row-colomn-style">
                            {{ w.employee }}
                          </td>
                          <td class="row-colomn-style">
                            {{ (w.timeSpentSeconds / 3600).toFixed(2) }}
                          </td>
                          <td class="row-colomn-style">
                            {{ w.comment }}
                          </td>
                          <td class="row-colomn-style">
                            {{ (w.payedSeconds / 3600).toFixed(2) }}
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td>
            <div class="footer-space print">
              &nbsp;
            </div>
          </td>
        </tr>
      </tfoot>
    </table>
    <div class="pageHeader print">
      <img
        src="../../../../public/logo.png"
        width="150px"
      >
    </div>
    <div class="pageFooter print">
      <v-divider />
      <table>
        <tr>
          <td width="100%">
            {{ `Звіт сформовано: ${dateNow}` }}
          </td>
          <td width="100%">
            <img
              class="ml-3 mt-2"
              src="../../../../public/pageFooter.png"
            >
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => ([]),
    },
    filter: {
      type: Object,
      default: () => ({}),
    },
    updateTotalPayed: {
      type: [Number, String],
      default: "0.00",
    },
    updateTotalSpent: {
      type: [Number, String],
      default: "0.00",
    },
    unableToManageLogs: {
      type: Boolean,
      default: true,
    },
    projects: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    showWorklogDetails: false,
  }),
  date() {
    return {
      dateNow: null,
    };
  },
  computed: {
    client() {
      if (this.items.length === 0) {
        return "";
      }
      return this.items[0].client;
    },
  },
  created() {
    const now = Date.now();
    this.dateNow = this.moment(now).format("DD.MM.YYYY");
  },
  methods: {
    findWorkingImage(issueItem) {
      if (issueItem.description.includes("jira-attachment-thumbnail")) {
        return issueItem.description;
      }
      if (issueItem.description.includes("img")) {
        const newDescription = issueItem.description.replace(new RegExp("src=\"", "g"), "src=\"https://atominc.atlassian.net");
        return `${newDescription}`;
      } else {
        return issueItem.description;
      }
    },
  },
};
</script>
<style>
.pageHeader,
.header-space,
.pageFooter,
.footer-space {
  height: 50px;
}
.print {
  display: none;
}
.pageHeader {
  position: fixed;
  top: 0;
  right: 0;
}
.pageFooter {
  position: fixed;
  bottom: 0;
}
.image-wrap img {
  max-width: 1000px;
  width: 100%;
  object-fit: contain;
  object-position: left;
}
</style>
